import { NgModule } from '@angular/core';
import { StepComponent } from './components/step/step.component';
import { StepContentDirective } from './directives/step-content.directive';
import { StepFooterDirective } from './directives/step-footer.directive';
import { StepperComponent } from './stepper.component';


@NgModule({
  declarations: [],
  imports: [
    StepperComponent,
    StepComponent,
    StepContentDirective,
    StepFooterDirective,
  ],
  exports: [
    StepperComponent,
    StepComponent,
    StepContentDirective,
    StepFooterDirective,
  ],
})
export class StepperModule { }
